"use client";

import { jsonRpcProvider } from "@wagmi/core/providers/jsonRpc";
import React, { useState } from "react";
import { configureChains, createConfig, WagmiConfig } from "wagmi";

import { chains } from "./chains";

const whiteListChains = chains.filter((chain) => {
  if (process.env.NEXT_PUBLIC_CHAIN_WHITELIST) {
    const whitelisted = process.env.NEXT_PUBLIC_CHAIN_WHITELIST.split(",");
    if (whitelisted.length > 0) {
      return whitelisted.includes(chain.id.toString());
    }
  }
  return true;
});

const provider = jsonRpcProvider({
  rpc: (chain) => ({
    http: chain.rpcUrls.default.http[0]!,
  }),
});

export const Web3Provider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [{ publicClient }] = useState(
    configureChains(whiteListChains, [provider]),
  );

  const wagmiConfig = createConfig({
    autoConnect: true,
    publicClient,
  });

  return <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>;
};
